module.exports = __webpack_public_path__ + "img/loginBG.7cb5764f.png";